import React, { useEffect, useState } from "react";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window.google) {
      setLoaded(true);
      return;
    }

    const script = document.createElement("script");
    // Places (New): load core JS only; Places library is loaded via importLibrary("places").
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA0JPF7oQ3kjtsIo_p5dS0mzcZahW0jXs4&loading=async&v=weekly`;
    script.async = true;
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);
  }, []);

  if (!loaded) return <div></div>;

  return <AppRoutes />;
}

export default App;
